import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck, Loader2 } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return <div className="min-h-screen bg-[#09090B] flex items-center justify-center text-zinc-400"><Loader2 className="w-5 h-5 animate-spin mr-2" /> Verificando...</div>;
  }

  return (
    <div className="min-h-screen bg-[#09090B] text-white flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <Link to="/" data-testid="back-home-admin-link" className="inline-flex items-center text-sm text-zinc-400 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4 mr-1" /> Volver
        </Link>
        <div className="flex items-center gap-4 mb-6">
          <img src={BRAND.LOGO_AM} alt="AM Norte" className="h-10" />
          <div className="h-8 w-px bg-zinc-800" />
          <img src={BRAND.LOGO_SO} alt="Servicios Oficiales" className="h-8 invert opacity-80" />
        </div>
        <h1 className="text-3xl font-bold mb-2">Panel administrador</h1>
        <p className="text-zinc-400 text-sm mb-8">
          Acceso reservado para Servicios Oficiales. Ingresá con tu cuenta Google autorizada.
        </p>
        <Button
          data-testid="google-login-btn"
          onClick={login}
          className="w-full bg-[#FF5A00] hover:bg-[#E04F00] rounded-sm h-12 text-base"
        >
          <ShieldCheck className="w-4 h-4 mr-2" /> Ingresar con Google
        </Button>
      </div>
    </div>
  );
}
